import React, { useContext } from "react";
import { connect } from "react-redux";
import history from "../history";
import {
  AdsSortOption,
  CurrentPage,
  LocaleCode,
  PageRoute,
  QueryParam
} from "../models/enums";
import { checkEmptyObject, stringifyURI } from "../services";
import { updateCriteriaModules } from "../routes/Search/search.ducks";
import { SearchMode } from "../models/enums";
import ReactGA from "react-ga4";
import { Context } from "../GAContext";
import config from "appConfig";
import styles from "../containers/HomePage/styles/SearchBar.scss";
import { mapCategoryToHr, mapModuleToHr } from "../routes/LanguageMapper";

interface SearchBarSuggestionProps {
  searchText: string;
  item: { name: string; module: string; count: number };
  modules: any;
  categories: any;
  addRecentSearch: any;
  clearCriteriaModules: any;
  setError: Function;
  setShowMobileStyle: Function;
  addRootScrollBar: Function;
  isMobile: boolean;
  handleInputBlur: any;
}

function SearchBarSuggestion(props: SearchBarSuggestionProps) {
  const {
    searchText,
    item: { name, module, count },
    modules,
    categories,
    addRecentSearch,
    clearCriteriaModules,
    setError,
    setShowMobileStyle,
    addRootScrollBar,
    isMobile,
    handleInputBlur
  } = props;

  const [GaEvent] = useContext(Context);

  const filteredCategory = categories.find((c: any) => c.name === name && c.moduleName === module);

  const categoryName = filteredCategory ? filteredCategory.name : null;

  const moduleName = filteredCategory ? filteredCategory.moduleName : null;

  const queryParams = {
    text: searchText,
    sortOption: AdsSortOption.mostRelevant,
    module: moduleName,
    category: categoryName
  };

  const replacePlaceholders = (text: string) => {
    const filteredModule = modules.find((m: any) => m.name === module);
    const filteredCategory = categories.find(
      (c: any) => c.name === name
    );

    const moduleName = checkEmptyObject(filteredModule)
      ? filteredModule.displayName
      : "";
    const categoryName = checkEmptyObject(filteredCategory)
      ? filteredCategory.displayName
      : "";

    return text.replace("{0}", moduleName).replace("{1}", categoryName);
  };

  const replaceCount = (text: string) => {
    // We are checking the last one or two digits that count ends with
    // to change the word "ads" (in Croatian "oglasi") in singular or plural
    if (
      config.localeCode === LocaleCode.hr &&
      String(count).slice(-2) == "11"
    ) {
      return text.replace("{0}", count.toString());
    } else if (
      config.localeCode === LocaleCode.hr &&
      String(count).slice(-1) == "1"
    ) {
      return text.replace("{0}", count.toString()).replace("oglasa", "oglas");
    } else {
      return text.replace("{0}", count.toString());
    }
  };

  const handleSearch = () => {
    // GA event triggered by picking suggestion on mouse click
    const label = {
      [CurrentPage.home]: "Odabir ponuđene pretrage - naslovna",
      [CurrentPage.search]: "Odabir ponuđene pretrage - rezultati pretrage",
      [CurrentPage.details]: "Odabir ponuđene pretrage - detalji oglasa",
      [CurrentPage.myAds]: "Odabir ponuđene pretrage - moji oglasi",
      [CurrentPage.module]: "Odabir ponuđene pretrage  - stranica kategorije",
    }[GaEvent]


    if (GaEvent != "") {
      ReactGA.event({
        category: "Pretraga",
        action: "Click",
        label: label || ""
      });
      ReactGA.event({
        category: "Tekstualna pretraga",
        action: "Click",
        label: "Odabir ponuđene opcije pojmovi - klasična"
      });
    }

    // GA4 event for tracking search terms
    ReactGA.event("view_search_results", {
      search_term: searchText.trim(),
      category: queryParams.category || "",
      results_count: count || 0,
      search_type: SearchMode.classic
    });

    addRecentSearch(queryParams.text, queryParams.module, queryParams.category);

    handleInputBlur();

    clearCriteriaModules();
    setError(false);
    setShowMobileStyle(false);
    addRootScrollBar();
    const url = `${queryParams.module ? `/${mapModuleToHr(queryParams.module)}` : ""}${queryParams.category
      ? `/${mapCategoryToHr(queryParams.category, queryParams.module)}`
      : ""
      }${PageRoute.search}${stringifyURI(queryParams, QueryParam.searchQuery)}`;
    const separator = url.includes("?") ? "&" : "?";
    history.push(`${url}${separator}search_type=${SearchMode.classic}&search_query=${encodeURIComponent(searchText.trim())}`);
  };

  return (
    <span className={styles.option} onClick={handleSearch}>
      <span style={{ marginRight: "5px" }}>
        <strong>{searchText}</strong>
        {" " + replacePlaceholders("u {0} / {1}")}
      </span>
      <span>{replaceCount(" ({0})")}</span>
    </span>
  );
}

function mapStateToProps(state: any) {
  return {
    modules: state.global.modules,
    categories: state.global.categories
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    clearCriteriaModules: () => dispatch(updateCriteriaModules(null))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBarSuggestion);



// WEBPACK FOOTER //
// ./src/utils/SearchBarSuggestion.tsx